// TODO(tsgo): Remove when microsoft/typescript-go#1034 is fixed (check after tsgo 7.1+)
import { deleteProductFamilies } from "./schema/delete-product-families";
import { getProductCatalog } from "./schema/get-product-catalog";
import { applyOptimizationDraft } from "./schema/listing-optimization/apply-optimization-draft";
import { applyOptimizationJobDrafts } from "./schema/listing-optimization/apply-optimization-job-drafts";
import { deleteGuidance } from "./schema/listing-optimization/delete-guidance";
import { discardOptimizationDraft } from "./schema/listing-optimization/discard-optimization-draft";
import { discardOptimizationJobDrafts } from "./schema/listing-optimization/discard-optimization-job-drafts";
import { getGuidance } from "./schema/listing-optimization/get-guidance";
import { upsertGuidance } from "./schema/listing-optimization/upsert-guidance";
import { bulkUpdateProductDetails } from "./schema/product-catalog/bulk-update-product-details";
import { streamListingFieldOptimization } from "./schema/product-catalog/stream-listing-field-optimization";
import { getProductTaxonomy } from "./schema/product-taxonomy-finder/get-product-taxonomy";
import { searchProductTaxonomy } from "./schema/product-taxonomy-finder/search-product-taxonomy";
import { publishProductFamilies } from "./schema/publish-product-families";
import { getRecommendedPurchaseOrders } from "./schema/purchase-orders/get-recommended-purchase-orders";
import { unpublishProductFamilies } from "./schema/unpublish-product-families";

export const groupH: {
  bulkUpdateProductDetails: typeof bulkUpdateProductDetails;
  streamListingFieldOptimization: typeof streamListingFieldOptimization;
  deleteProductFamilies: typeof deleteProductFamilies;
  publishProductFamilies: typeof publishProductFamilies;
  unpublishProductFamilies: typeof unpublishProductFamilies;
  getProductCatalog: typeof getProductCatalog;
  getProductTaxonomy: typeof getProductTaxonomy;
  searchProductTaxonomy: typeof searchProductTaxonomy;
  getRecommendedPurchaseOrders: typeof getRecommendedPurchaseOrders;
  applyOptimizationDraft: typeof applyOptimizationDraft;
  applyOptimizationJobDrafts: typeof applyOptimizationJobDrafts;
  deleteGuidance: typeof deleteGuidance;
  discardOptimizationDraft: typeof discardOptimizationDraft;
  discardOptimizationJobDrafts: typeof discardOptimizationJobDrafts;
  getGuidance: typeof getGuidance;
  upsertGuidance: typeof upsertGuidance;
} = {
  bulkUpdateProductDetails,
  streamListingFieldOptimization,
  deleteProductFamilies,
  publishProductFamilies,
  unpublishProductFamilies,
  getProductCatalog,
  getProductTaxonomy,
  searchProductTaxonomy,
  getRecommendedPurchaseOrders,
  applyOptimizationDraft,
  applyOptimizationJobDrafts,
  deleteGuidance,
  discardOptimizationDraft,
  discardOptimizationJobDrafts,
  getGuidance,
  upsertGuidance,
};
